module.exports = __webpack_public_path__ + "static/media/uci.69776517.png";